import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
    uri: process.env.REACT_APP_HASURA_GRAPHQL_URL,

    cache: new InMemoryCache({
        typePolicies: {
            Query: {
                fields: {
                    blog_posts: {
                        merge: false
                    }
                }
            }
        }
    }),
});

export default client;
